module.exports = __webpack_public_path__ + "img/img_space_card.7df4c64f.jpg";